import "../main/mobile.scss";
import { FaShoppingCart, FaBlog, FaRegUser } from "react-icons/fa";
import { BsHouseDoorFill, BsShop } from "react-icons/bs";
import { NavLink } from "react-router-dom";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { useContext } from "react";

const Mobile = () => {
  const auth = useContext(WithAuthentication);

  return (
    <div className="mobile">
      <div
        className="w-100 position-fixed mobile-style d-none "
        style={{
          bottom: 0,
          right: 0,
          left: 0,
          zIndex: 999,
          width: "100%",
          height: "80px",
        }}
      >
        <div
          className="btn-group bg-white w-100 shadow-lg position-relative"
          role="group"
          aria-label="Basic radio toggle button group"
          style={{ borderRadius: "35px" }}
        >
          <div className="item-container">
            <NavLink to="/" style={{ textDecoration: "none" }}>
              <label
                className="btn btn-outline-primary  item p-3"
                style={{ borderTopRightRadius: 35 }}
                htmlFor="btnradio4"
              >
                <BsHouseDoorFill className="fs-6 mb-1" />
                <br />

                <p className="user-name">خانه</p>
              </label>
            </NavLink>
          </div>
          <div className="item-container">
            <NavLink to="/store" style={{ textDecoration: "none" }}>
              <label
                className="btn btn-outline-primary  item p-3"
                // style={{ borderTopRightRadius: 35 }}
                htmlFor="btnradio4"
              >
                <BsShop className="fs-6 mb-1" />
                <br />

                <p className="user-name">فروشگاه</p>
              </label>
            </NavLink>
          </div>

          {auth.userInfo.userType == 1 && (
            <div
              className="text-center item-container mx-auto "
              data-bs-toggle="modal"
              data-bs-target="#CartModal"
              style={{ fontSize: "12px" }}
              style={{ cursor: "pointer" }}
            >
              <div
                className=" p-3 text-white mx-auto"
                style={{
                  borderRadius: "50%",
                  fontSize: 20,
                  width: "60px",
                  height: "60px",
                  backgroundColor: "#1C2140",
                  position: "relative",
                }}
              >
                <FaShoppingCart />
              </div>
            </div>
          )}
          <div className="item-container">
            <NavLink to="/blog" style={{ textDecoration: "none" }}>
              <label
                className="btn btn-outline-primary  item p-3"
                // style={{ borderTopRightRadius: 35 }}
                htmlFor="btnradio4"
              >
                <FaBlog className="fs-6 mb-1" />
                <br />

                <p className="user-name">بلاگ</p>
              </label>
            </NavLink>
          </div>
          {/* <div className="item-container">
            <NavLink to="/blog">
              <label
                className="btn btn-outline-primary item item-margin  p-3"
                htmlFor="btnradio3"
              >
                <FaBlog className="fs-6 mb-1" />
                <div>بلاگ</div>
              </label>
            </NavLink>
          </div> */}

          {!auth.isLogged ? (
            <div
              className="item-container"
              data-bs-toggle="modal"
              data-bs-target="#ModalNumber"
            >
              <label
                className="btn btn-outline-primary item p-3"
                style={{ borderTopLeftRadius: 35 }}
                htmlFor="btnradio4"
              >
                <FaRegUser className="fs-6 mb-1" />
                <br />
                ورود کاربر
              </label>
            </div>
          ) : (
            <>
              <div className="item-container">
                <NavLink
                  to={`${
                    auth.userInfo.userType == 0
                      ? "/admin-panel/dashboard"
                      : "/customer-panel/profile"
                  }`}
                  style={{ textDecoration: "none" }}
                >
                  <label
                    className="btn btn-outline-primary  item p-3"
                    style={{ borderTopLeftRadius: 35 }}
                    htmlFor="btnradio4"
                  >
                    <FaRegUser className="fs-6 mb-1" />
                    <br />

                    <p className="user-name">
                      {auth.userInfo.fullName == " "
                        ? "کاربر عزیز"
                        : auth.userInfo.fullName}
                    </p>
                  </label>
                </NavLink>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Mobile;
